<template>
    <div class="wysiwyg-editor-advanced" :id='"editor-" + this.asset_id'>
        <!-- Use a stable key so the editor is not remounted when switching between read-only and editable -->
        <QuillyEditor 
            :key="`editor-${asset_id}`" 
            v-model="local_input_value" 
            @focus="onEditorFocus" 
            :options="computedEditorOptions" 
            @blur="inputFieldValueChange" 
            @text-change="inputFieldValueChange"
            ref="textarea" 
        ></QuillyEditor>


    </div>
</template>
<script>
    import { QuillyEditor } from 'vue-quilly';
import Quill from 'quill';

    export default {
        name: 'WysiwygEditorAdvanced',
        components: { QuillyEditor },
        props: {
            input_value: {
                type: [String, null],
                default: ""
            },
            input_index: {
                type: [Number, null],
                default: null
            },
            asset_id: {
                type: [String, Number],
            },
            if_allow_edit: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {    
                local_input_value: null,
                local_input_value_html: null,
                is_valid_html: true,
                form: {
                    successful: false,
                    busy: false,
                    error: false,
                    warning: false,
                },
                editorFocused: null,
                editorOptions:{
                    theme: 'snow',
                    modules: {
                        toolbar: [
                            ["bold", "italic", "underline"],          
                            ["link"],
                            [{ list: "ordered" }, { list: "bullet" }]
                        ]
                    }
                }
            }
        },
        computed: {
            // Changing this key forces Vue to remount the QuillEditor which resets the readOnly state & CSS classes
            editorKey() {
                return this.if_allow_edit ? 'editor-enabled' : 'editor-disabled';
            },
            // Make editorOptions reactive to if_allow_edit changes
            computedEditorOptions() {
                return {
                    ...this.editorOptions,
                    readOnly: !this.if_allow_edit
                };
            }
        },
        watch:{
            input_value: {
                handler(new_value) {
                    this.local_input_value = new_value;
                    this.local_input_value_html = new_value;
                },
                immediate: true
            },

        },
        beforeMount() {
            this.local_input_value = this.input_value;
            this.local_input_value_html = this.local_input_value;
        },
        mounted() {
            // Initialize Quill editor
            this.$nextTick(() => {
                if (this.$refs.textarea) {
                    this.$refs.textarea.initialize(Quill);
                }
            });
            
            // Add tooltips to all toolbar buttons
            const toolbarButtons = [
                { selector: '.ql-bold', title: 'Bold' },
                { selector: '.ql-italic', title: 'Italic' },
                { selector: '.ql-underline', title: 'Underline' },
                { selector: '.ql-link', title: 'Insert Link', hasCustomIcon: true },
                { selector: '.ql-list[value="ordered"]', title: 'Numbered List' },
                { selector: '.ql-list[value="bullet"]', title: 'Bulleted List' }
            ];

            toolbarButtons.forEach(({ selector, title, hasCustomIcon }) => {
                const buttons = document.querySelectorAll('#editor-' + this.asset_id + ' ' + selector);
                if (buttons.length) {
                    buttons.forEach(button => {
                        // For link button, replace the icon with Font Awesome icon
                        if (hasCustomIcon && button.children.length > 0) {
                            button.removeChild(button.children[0]);
                            let node = document.createElement('i');
                            node.classList.add('fa', 'fa-btn', 'fa-link');
                            button.appendChild(node);
                        }
                        
                        // Add tooltip attributes
                        button.setAttribute('data-bs-toggle', 'tooltip');
                        button.setAttribute('data-bs-placement', 'bottom');
                        button.setAttribute('title', title);
                    });
                }
            });

            // Initialize tooltips
            const tooltipTriggerList = document.querySelectorAll('#editor-' + this.asset_id + ' [data-bs-toggle="tooltip"]');
            const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new window.bootstrap.Tooltip(tooltipTriggerEl)); 
        },
        methods: {
            onEditorFocus(quill) {    
                this.editorFocused = quill; 
            }, 
            inputFieldValueChange(){
                // Emit only when content actually changes to avoid update loops
                if (this.local_input_value !== this.input_value) {
                    this.local_input_value_html = this.local_input_value;
                    this.$nextTick(() => {
                        this.$emit('wysiwygValueChange', {value: this.local_input_value, index: this.input_index});
                    });
                }
            },
            closeModal(id) {
                let myModalEl = document.getElementById(id)
                let modal = bootstrap.Modal.getInstance(myModalEl);
                modal.hide();
            },    
        }
    }
</script>
